import './teaser-collection.scss';

// import { Slider } from '../slider/slider';
import Swiper, { Manipulation } from 'swiper';
import { Loader } from '../../services/loader';
import { createElementFromHTML } from '../../utilities/js/helper.js';

class TeaserCollection {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-teaser-collection',
            itemsAttr: 'slides',
            itemAttr: 'slide',
            toggleAttr: 'toggle',
            loader: 'data-teaser-collection-loader',
            loaderHandle: 'data-teaser-collection-loaderhandle',
            loading: null,
            onSubmitted: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$teaserCollection = element;

        this.$loader = this.$teaserCollection.querySelector('[' + this.settings.loader + ']');
        this.$loaderHandle = this.$teaserCollection.querySelector('[' + this.settings.loaderHandle + ']');
        this.$slider = this.$teaserCollection.querySelector('[' + this.settings.initAttr + '="slides"]');
        this.$itemsWrapper = this.$teaserCollection.querySelector('[' + this.settings.initAttr + '="' + this.settings.itemsAttr + '"]');
        this.$$toggle = this.$teaserCollection.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');
        this.mobile = null;
        this.slider = null;
        this.actionHandler = null;
    }

    initialize () {
        if (window.innerWidth < 1024) {
            this.mobile = true;
            this.$teaserCollection.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"][value="slider"]').checked = true;
        } else {
            this.mobile = false;
        }

        this.setState();
        this.setEvents();

        if (this.$loader) {
            this.initLoader(this.$loader);
        }
    }

    initSlider (slider) {
        this.slider = new Swiper(this.$teaserCollection.querySelector('.teaser-collection__content'), {
            modules: [Manipulation],
            autoHeight: false,
            resistance: true,
            resistanceRatio: 0,
            slidesPerView: 'auto',
            speed: 750
        });

        this.slider.update();
    }

    destroySlider () {
        if (typeof this.slider === 'object') {
            this.slider.destroy();
            this.slider = null;
        }
    }

    setState (view) {
        if (typeof view === 'undefined') {
            view = this.$teaserCollection.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]:checked').value;
        }

        if (this.mobile === false) {
            if (this.slider !== null) {
                this.destroySlider();
            }
        } else {
            if (view === 'slider') {
                this.initSlider(this.$teaserCollection);
            } else {
                if (this.slider !== null) {
                    this.destroySlider();
                }
            }
        }
    }

    initLoader ($loader) {
        this.loader = new Loader($loader, {
            loading: this.settings.loading,
            initAttr: this.settings.loader,
            handleAttr: this.settings.loaderHandle,
            external: true,
            onSubmitted: (results) => {
                if (typeof results !== 'undefined' && results !== '') {
                    const resultsJSON = JSON.parse(results);

                    if (typeof resultsJSON === 'object' && typeof resultsJSON.nextPageUrl !== 'undefined' && typeof resultsJSON.template !== 'undefined') {
                        const nextPageUrl = resultsJSON.nextPageUrl;
                        const $newItems = createElementFromHTML(resultsJSON.template);

                        if (nextPageUrl !== null) {
                            this.$loaderHandle.href = nextPageUrl;
                        } else {
                            this.$loader.classList.add('is--hidden');
                        }

                        const $newContent = document.createElement('div');

                        $newItems.forEach(item => {
                            $newContent.appendChild(item);
                        });

                        if (typeof this.settings.onSubmitted === 'function') {
                            this.settings.onSubmitted($newContent);
                        }

                        if (this.$teaserCollection.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]:checked').value === 'slider') {
                            $newItems.forEach(item => {
                                item.classList.add('.swiper-slide');
                                this.slider.appendSlide(item);
                            });
                        } else {
                            $newItems.forEach(item => {
                                this.$itemsWrapper.appendChild(item);
                            });
                        }
                    }
                }
            }
        });

        this.loader.initialize();
    }

    setEvents () {
        document.addEventListener('design_s', () => {
            this.mobile = true;
            this.setState();
        });

        document.addEventListener('design_m', () => {
            this.mobile = true;
            this.setState();
        });

        document.addEventListener('design_l', () => {
            this.mobile = false;
            this.$teaserCollection.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"][value="list"]').checked = true;
            this.setState();
        });

        this.$$toggle.forEach(button => {
            button.addEventListener('change', () => {
                this.setState(button.value);
            });
        });
    }
}

export { TeaserCollection };
